import * as React from 'react';
import { observer } from 'mobx-react';
import { Form } from './form';
import { FieldValues, Form as IForm, FormField, FormFields } from '../types/form';
import { createOnboardingForm } from '../lib/form';
import { style } from 'typestyle';
import { UIHeroGenre } from '../types/ui';

export interface FormOnboardingFields extends FormFields {
  email: FormField<string>;
  first_name: FormField<string>;
  last_name: FormField<string>;
  country: FormField<string>;
  age: FormField<string>;
  marketing_allowed: FormField<boolean>;
  accepted_terms: FormField<boolean>;
}

export type FormOnboardingModel = IForm<FormOnboardingFields>;

export interface FormOnboardingProps {
  onSubmit(fields: FormOnboardingFields): void;
  defaultValues?: FieldValues<FormOnboardingFields>;
  error: string;
  saving: boolean;
  genres: Array<UIHeroGenre>;
}

@observer
export class FormOnboarding extends React.Component<FormOnboardingProps, FormOnboardingModel> {
  render() {
    return (
      <Form
        className={FormOnboarding.styles.form}
        model={this.state}
        autoFocus="email"
        onSubmit={this.handleSubmit}
        onChange={this.handleChange}
      />
    );
  }

  constructor(props) {
    super(props);
    this.state = createOnboardingForm(this.getInitialValues(), props.genres);
  }

  handleSubmit = () => this.props.onSubmit(this.state.fields);
  handleChange = (field: string, value: any) =>
    this.setState(({ fields }) => ({
      fields: {
        ...fields,
        [field]: {
          ...fields[field],
          value,
        },
      },
    }));

  getInitialValues() {
    let initialValues: FieldValues<FormOnboardingFields> = this.props.defaultValues;
    if (!process.env.SERVER && 'lickd_upfront_onboarding' in window.sessionStorage) {
      try {
        const { termsCheckbox, marketingCheckbox } = JSON.parse(
          window.sessionStorage.getItem('lickd_upfront_onboarding'),
        );
        initialValues = { ...initialValues, accepted_terms: !!termsCheckbox, marketing_allowed: !!marketingCheckbox };
      } catch {
        // State is corrupt, use default
      }
    }
    return initialValues;
  }

  componentWillMount() {
    this.setState(createOnboardingForm(this.getInitialValues(), this.props.genres));
  }

  componentWillReceiveProps(nextProps) {
    this.setState(({ error }) => ({
      error: nextProps.error,
      saving: nextProps.saving,
    }));
  }

  static styles = {
    form: style({
      $nest: {
        '& [role="button"]:first-of-type': {
          display: 'none',
        },
      },
    }),
  };
}
